import { z } from 'zod';

export const AREA = 'Area';
export const DISTRICT = 'District';
export const SECTOR = 'Sector';
export const SUBUNIT = 'SubUnit';
export const CoastGuardLevelNames = z.literal([
  AREA,
  DISTRICT,
  SECTOR,
  SUBUNIT,
]);
export const AORHierarchyNodeSchema = z.object({
  id: z.uuid(),
  name: z.string(),
  description: z.string().nullable(),
  parentItemId: z.uuid().nullable(),
  location: z.string().nullable(),
  currentLocationGeom: z.string().nullable(),
});

export const AORsByHierarchyLevelSchema = z.object({
  levelOrder: z.number().int().min(1).max(5),
  levelName: CoastGuardLevelNames,
  aors: z.array(AORHierarchyNodeSchema),
});

export const AORsByHierarchyLevelPayloadSchema = z.array(
  AORsByHierarchyLevelSchema
);

export type AORHierarchyNode = z.infer<typeof AORHierarchyNodeSchema>;
export type AORsByHierarchyLevel = z.infer<typeof AORsByHierarchyLevelSchema>;
export type AORsByHierarchyLevelPayload = z.infer<
  typeof AORsByHierarchyLevelPayloadSchema
>;
export type CoastGuardLevelName = z.infer<typeof CoastGuardLevelNames>;
